import React, { useEffect, useState } from 'react';
import { TextInput } from '../../../shared/components/TextInput';
import { validateAgendamento } from '../validation/recrutamentoForms';
import { RecrutamentoModal } from './RecrutamentoModal';

interface AgendarModalProps {
  open: boolean;
  candidato: string;
  etapaAtual: string;
  /** `true` quando a etapa já tem agendamento vigente. */
  isReagendamento?: boolean;
  loading?: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: (input: { scheduledAt: string; location?: string; meetingLink?: string }) => void;
}

/**
 * Agendamento da etapa corrente.
 *
 * A data mínima é "agora": o servidor recusa data no passado, e deixar o
 * campo aceitar ontem só produziria um 400 evitável.
 */
export function AgendarModal({
  open,
  candidato,
  etapaAtual,
  isReagendamento,
  loading,
  error,
  onCancel,
  onConfirm,
}: AgendarModalProps) {
  const [scheduledAt, setScheduledAt] = useState('');
  const [location, setLocation] = useState('');
  const [meetingLink, setMeetingLink] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setScheduledAt('');
      setLocation('');
      setMeetingLink('');
      setTouched(false);
    }
  }, [open]);

  const erro = validateAgendamento(scheduledAt);

  return (
    <RecrutamentoModal
      open={open}
      title={isReagendamento ? 'Reagendar etapa' : 'Agendar etapa'}
      description={`${candidato} — ${etapaAtual}. O candidato recebe a data por e-mail; os participantes internos recebem notificação.`}
      submitLabel={isReagendamento ? 'Reagendar' : 'Agendar'}
      isSubmitting={loading}
      submitError={error}
      canSubmit={erro === null}
      onClose={onCancel}
      onSubmit={() => {
        setTouched(true);
        if (erro) return;
        onConfirm({
          scheduledAt: new Date(scheduledAt).toISOString(),
          location: location.trim() || undefined,
          meetingLink: meetingLink.trim() || undefined,
        });
      }}
    >
      <TextInput
        label="Data e hora"
        type="datetime-local"
        value={scheduledAt}
        onChange={(event) => setScheduledAt(event.target.value)}
        onBlur={() => setTouched(true)}
        error={touched && erro ? erro : undefined}
      />
      <TextInput
        label="Local (opcional)"
        value={location}
        onChange={(event) => setLocation(event.target.value)}
      />
      <TextInput
        label="Link da reunião (opcional)"
        value={meetingLink}
        onChange={(event) => setMeetingLink(event.target.value)}
      />
    </RecrutamentoModal>
  );
}
